var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full-topics"},[_c('div',{ref:"graph",staticClass:"graph-content"}),_c('div',{staticClass:"black",class:{'black-class':_vm.fullClass},on:{"click":_vm.goBlack}},[_vm._v("Exit")])])
}
var staticRenderFns = []

export { render, staticRenderFns }